import { useEffect } from "react";
import BlogService from "../Service/BlogService";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const CreateAddress = (addresse) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const createArticleWithImages = async () => {
            try {
                await BlogService.postAddress(addresse.addresse);
                window.location.reload();
            } catch (error) {
                console.error("Erreur lors de la création de l'article :", error);
            }
        };

        createArticleWithImages();
    }, [addresse, dispatch, navigate]);

    return null; // This component does not render anything
};

export default CreateAddress;